import { render, staticRenderFns } from "./AddCustomerQuote.vue?vue&type=template&id=0237c9dd&scoped=true&"
import script from "./AddCustomerQuote.vue?vue&type=script&lang=js&"
export * from "./AddCustomerQuote.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomerQuote.vue?vue&type=style&index=0&id=0237c9dd&lang=scss&"
import style1 from "./AddCustomerQuote.vue?vue&type=style&index=1&id=0237c9dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0237c9dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0237c9dd')) {
      api.createRecord('0237c9dd', component.options)
    } else {
      api.reload('0237c9dd', component.options)
    }
    module.hot.accept("./AddCustomerQuote.vue?vue&type=template&id=0237c9dd&scoped=true&", function () {
      api.rerender('0237c9dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/quotation/AddCustomerQuote.vue"
export default component.exports